import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import {
  DELETE_EMAIL_TEMPLATE_FAILURE,
  DELETE_EMAIL_TEMPLATE_REQUEST,
  DELETE_EMAIL_TEMPLATE_SUCCESS,
  GET_EMAIL_TEMPLATE_FAILURE,
  GET_EMAIL_TEMPLATE_REQUEST,
  GET_EMAIL_TEMPLATE_SUCCESS,
  GET_EMAIL_TEMPLATE_TOKENS_FAILURE,
  GET_EMAIL_TEMPLATE_TOKENS_REQUEST,
  GET_EMAIL_TEMPLATE_TOKENS_SUCCESS,
  GET_EMAIL_TEMPLATES_SUMMARIES_FAILURE,
  GET_EMAIL_TEMPLATES_SUMMARIES_REQUEST,
  GET_EMAIL_TEMPLATES_SUMMARIES_SUCCESS,
  POST_EMAIL_TEMPLATE_FAILURE,
  POST_EMAIL_TEMPLATE_REQUEST,
  POST_EMAIL_TEMPLATE_SUCCESS,
  POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_FAILURE,
  POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_REQUEST,
  POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_SUCCESS,
  POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_FAILURE,
  POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_REQUEST,
  POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_SUCCESS,
  PUT_EMAIL_TEMPLATE_FAILURE,
  PUT_EMAIL_TEMPLATE_REQUEST,
  PUT_EMAIL_TEMPLATE_SET_ACTIVE_FAILURE,
  PUT_EMAIL_TEMPLATE_SET_ACTIVE_REQUEST,
  PUT_EMAIL_TEMPLATE_SET_ACTIVE_SUCCESS,
  PUT_EMAIL_TEMPLATE_SET_CANCELLED_FAILURE,
  PUT_EMAIL_TEMPLATE_SET_CANCELLED_REQUEST,
  PUT_EMAIL_TEMPLATE_SET_CANCELLED_SUCCESS,
  PUT_EMAIL_TEMPLATE_SUCCESS,
  SET_TEMPLATE_ID
} from './emailTemplateTypes';

export const getEmailTemplateSummaries = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EMAIL_TEMPLATES_SUMMARIES_REQUEST, GET_EMAIL_TEMPLATES_SUMMARIES_SUCCESS, GET_EMAIL_TEMPLATES_SUMMARIES_FAILURE],
      authenticated: true,
      endpoint: `api/templates`,
      method: 'GET'
    }
  };
};

export const postRenderAuthorizationEmailTemplate = (templateId, authId, request) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_REQUEST,
        POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_SUCCESS,
        POST_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_FAILURE
      ],
      authenticated: true,
      endpoint: `api/templates/${templateId}/authorizations/${authId}`,
      method: 'POST',
      payload: request
    }
  };
};

export const postSendRenderAuthorizationEmailTemplate = (templateId, authId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_REQUEST,
        POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_SUCCESS,
        POST_SEND_RENDER_AUTHORIZATION_EMAIL_TEMPLATE_FAILURE
      ],
      authenticated: true,
      endpoint: `api/templates/${templateId}/authorizations/${authId}/send`,
      method: 'POST',
      payload: values
    }
  };
};

export const postEmailTemplate = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_EMAIL_TEMPLATE_REQUEST, POST_EMAIL_TEMPLATE_SUCCESS, POST_EMAIL_TEMPLATE_FAILURE],
      authenticated: true,
      endpoint: `api/templates/`,
      method: 'POST',
      payload: values
    }
  };
};

export const getEmailTemplate = templateId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EMAIL_TEMPLATE_REQUEST, GET_EMAIL_TEMPLATE_SUCCESS, GET_EMAIL_TEMPLATE_FAILURE],
      authenticated: true,
      endpoint: `api/templates/${templateId}`,
      method: 'GET'
    }
  };
};

export const putEmailTemplate = (templateId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [PUT_EMAIL_TEMPLATE_REQUEST, PUT_EMAIL_TEMPLATE_SUCCESS, PUT_EMAIL_TEMPLATE_FAILURE],
      authenticated: true,
      endpoint: `api/templates/${templateId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteEmailTemplate = templateId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_EMAIL_TEMPLATE_REQUEST, DELETE_EMAIL_TEMPLATE_SUCCESS, DELETE_EMAIL_TEMPLATE_FAILURE],
      authenticated: true,
      endpoint: `api/templates/${templateId}`,
      method: 'DELETE'
    }
  };
};

export const getEmailTemplateTokens = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_EMAIL_TEMPLATE_TOKENS_REQUEST, GET_EMAIL_TEMPLATE_TOKENS_SUCCESS, GET_EMAIL_TEMPLATE_TOKENS_FAILURE],
      authenticated: true,
      endpoint: `api/templates/tokens`,
      method: 'GET'
    }
  };
};

export const putEmailTemplateSetActive = (templateId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [PUT_EMAIL_TEMPLATE_SET_ACTIVE_REQUEST, PUT_EMAIL_TEMPLATE_SET_ACTIVE_SUCCESS, PUT_EMAIL_TEMPLATE_SET_ACTIVE_FAILURE],
      authenticated: true,
      endpoint: `api/templates/${templateId}/active`,
      method: 'PUT',
      payload: values
    }
  };
};

export const putEmailTemplateSetCancelled = (templateId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [PUT_EMAIL_TEMPLATE_SET_CANCELLED_REQUEST, PUT_EMAIL_TEMPLATE_SET_CANCELLED_SUCCESS, PUT_EMAIL_TEMPLATE_SET_CANCELLED_FAILURE],
      authenticated: true,
      endpoint: `api/templates/${templateId}/cancel`,
      method: 'PUT',
      payload: values
    }
  };
};

export const setTemplateId = templateId => {
  return {
    type: SET_TEMPLATE_ID,
    response: templateId
  };
};
